var $35da740d59af89ba$exports = {};
const $35da740d59af89ba$var$root = document.documentElement;
function $35da740d59af89ba$var$getContainerDeltaWidth() {
    const windowWidth = window.innerWidth;
    const maxContainerWidth = 1479;
    return windowWidth > maxContainerWidth ? (windowWidth - maxContainerWidth) / 2 : 0;
}
function $35da740d59af89ba$var$setContainerDelta() {
    const delta = $35da740d59af89ba$var$getContainerDeltaWidth();
    console.log(delta, window.innerWidth);
    $35da740d59af89ba$var$root.style.setProperty("--container-delta-width", delta + "px");
}
window.onresize = ()=>{
    $35da740d59af89ba$var$setContainerDelta();
};
window.onload = ()=>{
    $35da740d59af89ba$var$setContainerDelta();
};
document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
    anchor.addEventListener("click", function(e) {
        e.preventDefault();
        document.querySelector(this.getAttribute("href")).scrollIntoView({
            behavior: "smooth"
        });
    });
});


//# sourceMappingURL=index.dcb0af3a.js.map
